/*
 * SVGO plugin to simplify "path" shapes to include only M, L and C instructions.
 *
 * Adapted from Snap.svg (@see http://snapsvg.io/), specifically from these:
 *
 * https://github.com/adobe-webplatform/Snap.svg/blob/master/src/path.js
 * https://github.com/adobe-webplatform/Snap.svg/blob/master/src/svg.js
 */
import { map }         from 'ramda'
import Snap  from '../snapsvg-lite'

const round               = n => Math.round(n * 100) / 100
const instructionToString = ([instruction, ...values]) => `${ instruction } ${ map(round, values).join(' ') }`
const curveToString       = d => map(instructionToString, d).join('')

/*
 * A facade to adapt path2curve (above; based on snapsvg.io) into the signature required for SVGO plugins
 */
const processPath = item => {
    const curve = Snap.toCubic(item.attrs.d.value)
    item.addAttr({ name: 'd', value: curveToString(curve), prefix: '', local: 'd' })
}

const simplifyPathToOnlyMlc = {
    type       : 'perItem',
    active     : true,
    description: 'Simplify a path so it contains only M, L and C commands',
    params     : {},
    fn         : item => (item.elem === 'path') ? processPath(item) : item,
}

export { simplifyPathToOnlyMlc }
